import React from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Filter from '../../Filter/Filter';
import Filters from '../../Filters/Filters';

const AssignmentFilters = React.memo(props => {
  const {
    assignments: {
      assignments: { facet_fields },
    },
  } = props;

  return (
    <Filters>
      <Filter type="text" name="search" title="Search" placeholder="Search content assignments" />
      <Filter type="preset" preset="depth" name="folderDepth" title="Include subfolders" />
      <Filter type="checkbox" name="type" title="Type" data={facet_fields.type} />
      <Filter
        type="checkbox"
        name="content_type"
        title="Content Type"
        data={facet_fields.content_type}
      />
      <Filter type="tag" name="tags" title="Tags" data={facet_fields.tags} />
    </Filters>
  );
});

AssignmentFilters.propTypes = {
  auth: PropTypes.object.isRequired,
  assignments: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  assignments: state.assignments,
});

export default withRouter(connect(mapStateToProps)(AssignmentFilters));
